<header class="modal-header bg-white border-bottom-0">
    <h5 class="modal-title" id="modal-basic-title font-weight-bold">Editor de Texto Ayuda</h5>
    <button type="button" class="close" (click)="onDismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </header>
  <section class="modal-body row">
      <angular-editor class="col-12" [config]="config" [formControl]="formControl"></angular-editor>
      <div class="col-12 text-center m-3">
          <button class="btn btn-primary" (click)="confirm()">Aceptar</button>
      </div>
    </section>

